import { Component, Input, Output, EventEmitter, ViewChild, OnInit } from '@angular/core';
import * as moment from 'moment';
import { IBoxService } from 'src/app/shared/services/i-box.service';
import { Document } from 'src/app/shared/models/iBox/document';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { FileChoiceModalComponent } from 'src/app/components/modals/file-choice-modal/file-choice-modal.component';
import { ConfirmationService } from 'primeng/api';
import * as async from 'async';
import * as _ from 'underscore';
import { saveAs } from 'file-saver';
import { GuardConfirmModalComponent } from 'src/app/components/modals/guard-confirm-modal/guard-confirm-modal.component';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DialogService } from 'primeng/dynamicdialog';
import * as XLSX from 'xlsx';
import { DocumentEditorService } from 'src/app/shared/services/document-editor.service';
import { v4 as uuidv4 } from 'uuid';
import { ChooseSourceTypeModalComponent } from 'src/app/components/modals/choose-source-type-modal/choose-source-type-modal.component';
import { TranslateService } from '@devinforius/i-essentials';
import { DropdownRole, DropdownService, MailFileDto, ServiceDto } from 'src/app/shared/interfaces';
import { ServicesService } from 'src/app/shared/services/services.service';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { nameAndSurnameConcatenater } from 'src/app/shared/utils/name-surname-concatenater.util';
import { DocumentsService } from 'src/app/shared/services/documents.service';
import { FileSelectEvent, FileUpload } from 'primeng/fileupload';
import { Contact } from 'src/app/shared/models/iContact/contact/contact';
import { Cols } from 'src/app/shared/models/cols';
import { HistoryValidationSignature } from 'src/app/shared/models/iCourrier/history-validation-signature';
import { Mail } from 'src/app/shared/models/mails/mail';
import { MeRightMail } from 'src/app/shared/models/iCourrier/me/right-mail-id';
import { RolesService } from 'src/app/shared/services/roles.service';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { UsersService } from 'src/app/shared/services/users.service';
import { ModalAssignPastellCircuitComponent } from 'src/app/components/modals/modal-assign-pastell-circuit/modal-assign-pastell-circuit.component';
import { PastellStatus } from 'src/app/shared/models/iCourrier/pastell/pastell-status';
import { OverlayPanel } from 'primeng/overlaypanel';
import { MeRightMailGlobal } from 'src/app/shared/models/iCourrier/me/right-mail-global';
import { UserDto } from 'src/app/shared/interfaces/users';
import { RecipientsService } from 'src/app/shared/services/recipients.service';
import { FilesService } from 'src/app/shared/services/files.service';
import { MeService } from 'src/app/shared/services/me.service';
import { Router } from '@angular/router';
import {
  MailFile,
  MailFileParams,
  MailFilesWithRights,
  MailsFilesAcceptValidationParams,
  MailsFilesRefuseValidationParams,
} from 'src/app/shared/models/mails/mail-file';
import { DocumentTemplateDTO } from 'src/app/shared/interfaces/documents/document-template-dto.interface';
import { DocumentValidationStatusDTO } from 'src/app/shared/interfaces/documents/document-validation-status-dto.interface';
import { DocumentSignatureStatusDTO } from 'src/app/shared/interfaces/documents/document-signature-status-dto.interface';
import { LibraryParagraphDto } from 'src/app/shared/interfaces/documents/library-paragraph-dto.interface';
import { PastellHistoryDTO } from 'src/app/shared/interfaces/mails/mail-pastell-history-dto.interface';
import { ExcelFilePublipostage } from 'src/app/shared/interfaces/files/excel-file-publipostage';
import { IButtonMenuItem } from '@devinforius/i-essentials/lib/models/i-button-menuitem';
import { DocumentInput } from 'src/app/shared/models';
import { DataService } from 'src/app/shared/services/data.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DestroyRef, inject } from '@angular/core';
import { forkJoin, of } from 'rxjs';

@Component({
  selector: 'app-courrier-create-add-files',
  templateUrl: './courrier-create-add-files.component.html',
  styleUrls: ['./courrier-create-add-files.component.scss'],
})
export class CourrierCreateAddFilesComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  public selectedFiles: number[] = []; //! ATTENTION Contient les INDEX, pas les ids!!!
  public selected_by_id: boolean[] = [];
  public displayFileAddString: string = '';
  public selectedTableLines: MailFile[] = [];

  @Input() set courrier(value: Mail) {
    this.currentCourrier = value;
    if (value) {
      this.setMailFilesDatas(true);
    }
  }
  @Input() public uploadedFiles: MailFile[] = [];
  @Input() public contactId: number;
  @Output() public currentFile = new EventEmitter<MailFile>(); // currentFile for superReader in courrierCreateComponent
  @Output() public currentAmountFile = new EventEmitter<number>(); // amount of files
  @Output() public mailModeEvent = new EventEmitter<string>();
  @Output() public reloadAfterValidationOrSignatureOfFile = new EventEmitter<{ status: boolean }>();
  @Output() public uploadedFilesAreSaved = new EventEmitter<boolean>();
  /**
   * When user drop files on the page, this function is called.
   * It adds the files to the current courrier and save them in the database.
   * @param value The array of files dropped by the user.
   */
  @Input() set uploadedFilesFromDragAndDrop(value: File[]) {
    if (value?.length > 0) {
      this.isLoading = true;
      this.spinner.show();
      async.eachSeries(
        value,
        (file: File, next) => {
          const newFile: File & { extension?: string; date?: moment.Moment; mailId?: number } = file;
          newFile.date = moment(new Date(file.lastModified), 'DD/MM/YYYY');
          newFile.extension = file.name.split('.').pop();
          newFile.mailId = this.currentCourrier.id;

          this.file = file;
          this.saveFile(file).then(() => {
            next();
          });
        },
        () => {
          this.spinner.hide();
          this.toastr.success(this.translater.translate('thankYou'), this.translater.translate('courrierFiche.filesAdded'));
          value = [];
          this.uploadedFilesAreSaved.emit(true);
        }
      );
    }
  }

  @Input() set forceSwitchFile(valueArray: number[]) {
    if (valueArray?.length > 0) {
      const value = valueArray[0];
      let file = null;
      // Plusieurs cas possible
      if (this.currentIndexFile === 0 && value === -1) {
        //Si on est au premier fichier et qu'on veut aller en arrière
        //on récupère le Dernier fichier
        file = this.uploadedFiles[this.uploadedFiles.length - 1];
        this.currentIndexFile = this.uploadedFiles.length - 1;
      } else if (this.currentIndexFile === this.uploadedFiles.length - 1 && value === 1) {
        //Si on est au dernier et qu'on veut aller en avant
        // On récupère le premier fichier
        file = this.uploadedFiles[0];
        this.currentIndexFile = 0;
      } else {
        if (value === -1) {
          file = this.uploadedFiles[this.currentIndexFile - 1];
          this.currentIndexFile = this.currentIndexFile - 1;
        } else {
          file = this.uploadedFiles[this.currentIndexFile + 1];
          this.currentIndexFile = this.currentIndexFile + 1;
        }
      }
      this.onOpenFile(file);
    }
  }
  @Input() rightMailInfo: MeRightMail;
  public rightMailInfoError: boolean = false;

  @ViewChild('pFileUpload') fileUpload: FileUpload;

  public document: Document;
  public file: File & { extension?: string; date?: moment.Moment; mailId?: number };
  public isLoading: boolean;
  public buttons: IButtonMenuItem[] = [];
  public buttonsSelectedFiles: IButtonMenuItem[] = [];
  public currentCourrier: Mail;

  public openedFileForSourceChange: boolean = false;
  public displayParagraphes: boolean = false;
  public LIST_IDS: string[];
  public paragraphes: Record<string, LibraryParagraphDto[]>;
  public searchValueBibli: string = '';

  slideConfig = {
    slidesToShow: 2,
    slidesToScroll: 2,
    dots: false,
    arrow: true,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 780,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
        },
      },
    ],
  };
  public currentIndexFile: number = 0;
  public statusValidation: Array<{ label: string; value: number; code: string }> = [];
  public statusSignature: { label: string; value: number }[] = [];
  public importModal: boolean = false;
  public courrierID: number;
  public filesFromCourriers: Array<MailFile> = [];
  public canDisplayDownloadAll: boolean = false;

  public columnsFiles: Cols[] = [
    {
      field: 'id',
      header: 'Id',
      format: (value) => {
        if (value) {
          return value;
        }
      },
    },
    {
      field: 'description',
      header: 'name',
      format: (_value, item) => {
        if (item.description && item.extension) {
          return item.description + '.' + item.extension;
        }
      },
    },
    {
      field: 'version',
      header: 'version',
      format: (value) => {
        if (value) {
          return value;
        }
      },
    },
  ];

  public showDescDialog: boolean = false;
  public filename: string = '';
  public showError: boolean = false;
  public fileCurrent: MailFile;
  public launchSearchImport: boolean = false;
  public showValidateDocument: boolean = false;
  public showRefuseDocument: boolean = false;
  public showValidateSignatureDocument: boolean = false;
  public showRefuseSignatureDocument: boolean = false;
  public formValidation = new UntypedFormGroup({
    justification: new UntypedFormControl(null),
    fileId: new UntypedFormControl(null),
  });
  public formSignature = new UntypedFormGroup({
    justification: new UntypedFormControl(null),
    dateRefus: new UntypedFormControl(null),
  });
  public fileID: number;
  public formModal = new UntypedFormGroup({
    fileId: new UntypedFormControl(null, Validators.required),
    previousStepId: new UntypedFormControl(null, Validators.required),
    previousStepName: new UntypedFormControl(null, Validators.required),
    contactId: new UntypedFormControl(null),
    justification: new UntypedFormControl(null),
    name: new UntypedFormControl(null),
  });
  public refuseItems: MailFile;
  public refuseModal: boolean = false;
  public services: DropdownService[] = [];
  public contacts: Contact[] = [];
  public columnsRefuse: Cols[] = [];
  public historiqueFile: HistoryValidationSignature[] = [];
  public roles: DropdownRole[] = [];
  public showModalHistorique: boolean = false;
  public size: number = 20;
  public side: string = '';
  public expandEnabled: boolean = false;
  public contentAnimation: boolean = false;
  public dotAnimation: boolean = false;
  public color: boolean = false;
  public filesToValidate: MailFileDto[] = [];
  public clientType: string = sessionStorage.getItem('clientType');
  public historiqueFilePastell: PastellHistoryDTO[] = [];
  public showModalHistoriquePastell: boolean = false;
  public statusPastell: { label: string; value: string }[] = [];
  public showPublipostage: boolean = false;
  public public_contacts: Contact[] = [];
  public formPubli = new UntypedFormGroup({
    pdf: new UntypedFormControl(false),
    fusion: new UntypedFormControl(false),
    contactIds: new UntypedFormControl(null),
    contactsLibres: new UntypedFormControl(null),
    fileId: new UntypedFormControl(null),
  });
  public excelFiles: File[] = [];
  public dataExcel: ExcelFilePublipostage[] = [];
  public colExcel: Cols[] = [
    {
      field: 'prenom',
      header: 'firstName',
      format: (value) => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'nom',
      header: 'lastName',
      format: (value) => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'titre',
      header: 'title',
      format: (value) => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'adresse',
      header: 'address',
      format: (value) => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'cp',
      header: 'ZIPCode',
      format: (value) => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'loc',
      header: 'location',
      format: (value) => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'mail',
      header: 'email',
      format: (value) => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'societe',
      header: 'compagny',
      format: (value) => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'tel',
      header: 'phone',
      format: (value) => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'fax',
      header: 'fax',
      format: (value) => {
        if (value) {
          return value;
        }
      },
    },
  ];
  public selectedPublipostageLibre: ExcelFilePublipostage[] = [];
  public filesToSign: MailFileDto[] = [];
  public showPDFModal = false;
  public pdfConverted: string;
  public currentPage: number = 1;
  public showUploadModalFile: boolean = false;
  public loadingDisplay: boolean = true;

  public modelTemplates: DocumentTemplateDTO[] = [];

  constructor(
    private iBoxService: IBoxService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private dialogService: DialogService,
    public formbuilder: UntypedFormBuilder,
    public documentEditorService: DocumentEditorService,
    public translater: TranslateService,
    private servicesService: ServicesService,
    private documentsService: DocumentsService,
    private rolesService: RolesService,
    private contactService: ContactsService,
    private usersService: UsersService,
    private recipientsService: RecipientsService,
    private filesService: FilesService,
    private meService: MeService,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.dataService
      .getRefreshFileList()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((fileIdToComeBackOn: number) => {
        this.spinner.show();
        this.getMailsFiles(fileIdToComeBackOn).then(() => {
          this.spinner.hide();
        });
      });
  }

  public setMailFilesDatas(onInit = false): void {
    this.getTranslations();
    let right: MeRightMailGlobal = null;
    this.rightMailInfoError = this.rightMailInfo === null ? true : false;
    this.uploadedFiles = [];

    forkJoin({
      meRightMailGlobal: this.meService.rightMailGlobal().pipe(
        catchError((err) => {
          this.displayError(err, 'error.errorOccurredWhileRetrievingRightMailGlobal');
          return of(null);
        })
      ),
      pastellStatus: this.clientType === 'JVS' ? this.getStatusPastell() : of(null),
      validationStatus: this.documentsService.getStatusValidationGlobal().pipe(
        catchError((err) => {
          this.displayError(err, 'error.errorOccurredWhileRetrievingStatusValidationGlobal');
          return of(null);
        })
      ),
      roles: this.rolesService.getRolesMappedToPrimeNGDropdowns().pipe(
        catchError((err) => {
          this.displayError(err, 'error.errorOccurredWhileFetchingRoles');
          return of(null);
        })
      ),
      services: this.servicesService.fetchMappedServicesToPrimeNGDropdowns().pipe(
        catchError((err) => {
          this.displayError(err, 'error.errorOccurredWhileFetchingServices');
          return of(null);
        })
      ),
      signatures: this.documentsService.getStatusSignatureGlobal().pipe(
        catchError((err) => {
          this.displayError(err, 'error.errorOccurredWhileRetrievingStatusSignatureGlobal');
          return of(null);
        })
      ),
    })
      .pipe(
        switchMap((res) => {
          right = res.meRightMailGlobal;
          this.formatValidationStatus(res.validationStatus);
          this.roles = res.roles;
          this.services = res.services;
          this.formatSignatures(res.signatures);
          return forkJoin({
            filesToValidate: right.menu.validationDocuments
              ? this.filesService.fetchMailFilesToValidate(this.currentCourrier.id).pipe(
                  catchError((err) => {
                    this.displayError(err, 'error.errorOccurredWhileRetrievingFilesToValidate');
                    return of(null);
                  })
                )
              : of(null),
            filesToSign: right.menu.signatureDocuments
              ? this.filesService.fetchMailFilesToSignIndividually(this.currentCourrier.id).pipe(
                  catchError((err) => {
                    this.displayError(err, 'error.errorOccurredWhileRetrievingFilesToSignIndividuels');
                    return of(null);
                  })
                )
              : of(null),
          });
        })
      )
      .subscribe((secondForkJoinResponse) => {
        this.filesToValidate = secondForkJoinResponse.filesToValidate;
        this.filesToSign = secondForkJoinResponse.filesToSign;
        this.getMailsFiles().then(() => {
          if (onInit) {
            //à l'initiation, on va setter d'abord le bouton qui permet d'ajouter un fichier, un document,... (afin d'avoir le get des modèles de documents)
            this.setAddFilesButtons().then(() => {
              this.setDownloadProperty().then(() => {
                this.loadingDisplay = false;
              });
            });
          }
        });
      });
  }

  private getTranslations(): void {
    this.columnsFiles.map((column) => {
      column.header = this.translater.translate(column.header);
    });
    this.colExcel.map((column) => {
      column.header = this.translater.translate(column.header);
    });
  }

  private getStatusPastell(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.filesService.getPastellStatutes().subscribe({
        next: (pastellStatus) => {
          if (pastellStatus?.length > 0) {
            pastellStatus.map((status) => {
              this.statusPastell.push({ label: status.description, value: status.status });
            });
          }
          resolve(true);
        },
        error: (err) => {
          this.displayError(err, 'error.errorOccurredWhileRetrievingStatusPastell');
        },
      });
    });
  }

  private formatValidationStatus(statusValidationGlobal: DocumentValidationStatusDTO[]): void {
    if (statusValidationGlobal.length) {
      statusValidationGlobal.forEach((status) => {
        this.statusValidation.push({ label: status.description, value: status.id, code: status.code });
      });
    }
  }

  private formatSignatures(statusSignatureGlobal: DocumentSignatureStatusDTO[]): void {
    if (statusSignatureGlobal.length) {
      statusSignatureGlobal.map((status) => {
        this.statusSignature.push({ label: status.description, value: status.id });
      });
    }
  }

  private getMailsFiles(fileIdToComeBackOn?: number): Promise<boolean> {
    return new Promise((resolve) => {
      this.filesService.getMailsFilesWithRights(this.currentCourrier.id).subscribe({
        next: (response) => {
          this.uploadedFiles = [];
          if (response.length > 0) {
            response.map((res) => {
              const file = new MailFilesWithRights(res);
              if (file.description && file.extension) {
                const hasExtensionInDescription = file.description.split('.').reverse()[0]; // store extension if present in the description
                file.hasExtensionInDescription = file.extension.toLowerCase() === hasExtensionInDescription.toLowerCase() ? true : false;
                if (file.rights.addNewVersion.authorized === true) {
                  file.hasRightToNewVersion = true;
                } else {
                  file.hasRightToNewVersion = false;
                }
              } // if file extension is the same than the variable => do not show extension
              else {
                file.hasExtensionInDescription = false;
              }

              if (file.rights.canValidate) {
                file.canPerformValidateAction = true;
              } else {
                file.canPerformValidateAction = false;
              }

              if (file.rights.canSign) {
                file.canPerformSignatureAction = true;
              } else {
                file.canPerformSignatureAction = false;
              }

              if (file.pastellStatus) {
                let temp = [];
                temp = this.statusPastell.filter((status) => status.value === file.pastellStatus);
                if (temp.length > 0) {
                  file.statusPastellLabel = _.first(temp).label;
                } else {
                  file.statusPastellLabel = '/';
                }
              }
              this.uploadedFiles.push(file);
            });
          }
          if (this.uploadedFiles.length > 0) {
            this.uploadedFiles.sort((fileA, fileB) => {
              if (fileA.isPrincipal !== fileB.isPrincipal) {
                return fileA.isPrincipal ? -1 : 1;
              }

              const dateA = new Date(fileA.dateUpload);
              const dateB = new Date(fileB.dateUpload);
              return dateA > dateB ? -1 : 1;
            });
            let firstFileToShow = null;
            if (fileIdToComeBackOn) {
              firstFileToShow = this.uploadedFiles.find((file) => file.id === fileIdToComeBackOn);
              this.currentIndexFile = this.uploadedFiles.findIndex((file) => file.id === fileIdToComeBackOn);
            } else {
              const arrayExtensionValid = ['docx', 'doc', 'pdf', 'jpg', 'png', 'jpeg', 'svg', 'eml', 'msg', 'rtf', 'txt', 'xlsx', 'xls'];
              for (let i = 0; i < this.uploadedFiles.length; i++) {
                if (arrayExtensionValid.includes(this.uploadedFiles[i].extension.toLowerCase())) {
                  firstFileToShow = this.uploadedFiles[i];
                  this.currentIndexFile = i;
                  break;
                }
              }
            }
            if (this.rightMailInfo?.files?.open) {
              this.onOpenFile(firstFileToShow);
            }
          }
          this.uploadedFiles.map((_item, index) => {
            this.selected_by_id[index] = false;
          });
          this.currentAmountFile.emit(this.uploadedFiles.length);
          resolve(true);
        },
        error: (error) => {
          this.displayError(error, 'error.errorOccurredWhileRetrievingMailsFiles');
        },
      });
    });
  }

  public setAddFilesButtons(): Promise<boolean> {
    return new Promise((resolve) => {
      this.documentsService.getGlobalTemplates().subscribe({
        next: (templates) => {
          this.modelTemplates = templates;
          if (this.rightMailInfo.files.add && this.rightMailInfo.files.edit && this.rightMailInfo.iCourrierWriteAuthorized) {
            this.displayFileAddString = 'addFile';
            this.buttons = [
              {
                label: this.translater.translate('courrierFiche.addFile'),
                icon: 'bi bi-plus-circle-fill me-2',
                click: () => {
                  this.onUploadClickv2();
                },
              },
              {
                label: this.translater.translate('courrierFiche.createDocument'),
                icon: 'bi bi-file-earmark-text-fill me-2',
                click: () => {
                  this.onDocCreateClick();
                },
              },
              {
                label: this.translater.translate('courrierFiche.importFiles'),
                icon: 'bi bi-envelope-arrow-down-fill me-2',
                click: () => {
                  this.importFromMail();
                },
              },
            ];
          }
          if (this.rightMailInfo.files.add === false && this.rightMailInfo.files.edit && this.rightMailInfo.iCourrierWriteAuthorized) {
            this.displayFileAddString = 'addFile';
            this.buttons = [
              {
                label: this.translater.translate('courrierFiche.addFile'),
                icon: 'bi bi-plus-circle-fill me-2',
                click: () => {
                  this.onUploadClickv2();
                },
              },
            ];
          }
          if (this.rightMailInfo.files.add && this.rightMailInfo.files.edit === false && this.rightMailInfo.iCourrierWriteAuthorized) {
            this.displayFileAddString = 'addDocument';
            this.buttons = [
              {
                label: this.translater.translate('courrierFiche.createDocument'),
                icon: 'bi bi-file-earmark-text-fill me-2',
                click: () => {
                  this.onDocCreateClick();
                },
              },
            ];
          }
          this.buttonsSelectedFiles = [
            {
              label: this.translater.translate('courrierFiche.downloadAllSelectedFiles'),
              icon: 'bi bi-download me-2',
              click: () => {
                this.downloadSelectedFiles();
              },
            },
          ];
          if (this.rightMailInfo?.files?.delete) {
            this.buttonsSelectedFiles.push({
              label: this.translater.translate('courrierFiche.deleteAllSelectedFiles'),
              icon: 'bi bi-trash-fill me-2',
              click: () => {
                this.deleteSelectedFiles();
              },
            });
          }
          const filePubliPostage = sessionStorage.getItem('showModalPublipostageFileID');
          const fileToImport = +sessionStorage.getItem('fileIdForImportation');
          if (filePubliPostage && !fileToImport) {
            this.formPubli.patchValue({
              fileId: filePubliPostage,
            });
            this.openPublipostage({ id: +filePubliPostage });
          }

          resolve(true);
        },
        error: (error) => {
          this.displayError(error, 'error.errorOccurredWhileRetrievingTemplates');
        },
      });
    });
  }

  public setDownloadProperty(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      //En premier lieu on va setter la propriété de téléchargement pour chaque fichier
      async.eachSeries(
        this.uploadedFiles,
        (file, next) => {
          if (file.extension === 'rtf') {
            const downloadFileRight = this.checkDowloadRight(file);
            file.downloadFileRight = downloadFileRight && this.rightMailInfo?.files?.open;
          } else {
            file.downloadFileRight = this.rightMailInfo?.files?.open;
          }
          next();
        },
        () => {
          //S'il existe au moins 1 fichier qui peut être téléchargé => on affiche le bouton
          const fileFound = this.uploadedFiles.find((file) => file.downloadFileRight);
          if (fileFound) this.canDisplayDownloadAll = true;
          else this.canDisplayDownloadAll = false;
          resolve(true);
        }
      );
    });
  }

  public onUploadClick(): void {
    document.getElementsByClassName('fileUploadCustom')[0].querySelector('input').click();
  }
  public onUploadClickv2(): void {
    document.getElementsByClassName('fileUploadCustomv2')[0].querySelector('input').click();
  }

  public onDocCreateClick(): void {
    const ref = this.dialogService.open(FileChoiceModalComponent, {
      dismissableMask: false,
      header: "Ajout d'un document",
      width: '60vw',
      baseZIndex: 1000,
    });
    ref.onClose.subscribe({
      next: (value: string) => {
        if (value === 'file') {
          this.onUploadClickv2();
        } else {
          if (value) {
            this.mailModeEvent.emit(value);
            this.router.navigate(['/private/ic/new/' + this.currentCourrier.id, { mode: value }]);
          }
        }
      },
    });
  }

  public onSelectFiles(event: FileSelectEvent): void {
    this.isLoading = true;
    this.spinner.show();
    const files = event.files?.length > 0 ? Array.from(event.files) : Array.from(event.currentFiles);
    const listOfFiles = [];
    files.forEach((file) => {
      const newFile: File & { extension?: string; date?: moment.Moment; mailId?: number; lastModifiedDate?: string } = file;
      newFile.extension = file.name.split('.').pop();
      newFile.date = moment(newFile.lastModifiedDate, 'DD/MM/YYYY');
      newFile.mailId = this.currentCourrier.id;
      listOfFiles.push(newFile);
    });
    async.eachSeries(
      listOfFiles,
      (file, next) => {
        this.file = file;
        this.saveFile(file).then(() => {
          next();
        });
      },
      () => {
        event.files = [];
        event.currentFiles = [];
        this.toastr.success(this.translater.translate('thankYou'), this.translater.translate('courrierFiche.filesAdded'));
        this.loadingDisplay = true;
        this.setMailFilesDatas(true);
      }
    );
  }

  public saveFile(file: File & { extension?: string; date?: moment.Moment; mailId?: number }): Promise<boolean> {
    return new Promise((resolve) => {
      this.document = new Document({
        description: file.name,
        version: 1,
      });

      this.filesService.addMailFiles(this.currentCourrier.id, this.document, this.file, file.extension, 'Externe').subscribe({
        next: (response) => {
          this.uploadedFiles.push(new MailFile(response));
          resolve(true);
        },
        error: (error) => {
          console.error('Error : ', error);
          this.spinner.hide();
          this.isLoading = false;
          this.toastr.error(this.translater.translate('error.errorOccurredWhileSavingFile'));
        },
      });
    });
  }
  public deleteSelectedFiles(): void {
    const deletedFiles = [];
    this.confirmationService.confirm({
      message: this.translater.translate('confirmation.deleteSelectedFiles'),
      key: 'deleteFileConfirm',
      accept: () => {
        //! Attention, ne pas oublier que selectedFiles contient un array des INDEX de fichiers sélectionnés! :D PAS les ids
        //! => on doit récupérer uploadedFiles[index].id en effet l'index récupéré est l'index du fichier dans uploadedFiles
        async.eachSeries(
          this.selectedFiles,
          (item, nextFile) => {
            // Supprimable UNIQUEMENT si l'un de ces status : ICOUR-4495
            if (
              this.uploadedFiles[item].pastellStatus === PastellStatus.AEnvoyer ||
              this.uploadedFiles[item].pastellStatus === PastellStatus.EnvoiEnCours ||
              this.uploadedFiles[item].pastellStatus === PastellStatus.Envoye
            ) {
              this.toastr.error(
                this.translater.translate('courrierFiche.errorFileInAPastellStatusNotDeletable') + ' : ' + this.uploadedFiles[item].description
              );
              nextFile();
            } else {
              this.filesService.deleteMailFile(this.currentCourrier.id, this.uploadedFiles[item].id).subscribe({
                next: () => {
                  this.toastr.success(this.translater.translate('thankYou'), this.translater.translate('courrierFiche.fileDeleted'));
                  deletedFiles.push(this.uploadedFiles[item].id);
                  nextFile();
                },
                error: (error) => {
                  console.error('Error : ', error);
                  this.toastr.error(this.translater.translate('error.errorOccurredWhileDeletingFile') + ' : ' + this.uploadedFiles[item].description);
                  nextFile();
                },
              });
            }
          },
          () => {
            //on va supprimer les fichiers qui ont été del. On les a mis dans un array a part au cas ou certains seraient problématiques.
            if (deletedFiles.length > 0) {
              deletedFiles.map((deletedFile) => {
                this.uploadedFiles = this.uploadedFiles.filter((uploadedFile) => uploadedFile.id !== deletedFile);
              });
            }
            this.selectedFiles = [];
            this.uploadedFiles.map((_item, index) => {
              this.selected_by_id[index] = false;
            });
            if (this.uploadedFiles.length > 0) {
              this.currentFile.emit(this.uploadedFiles[0]);
            } else {
              this.currentFile.emit(null);
            }
            this.currentAmountFile.emit(this.uploadedFiles.length);
          }
        );
      },
    });
  }

  public deleteFile(file: MailFile, op?: OverlayPanel): void {
    if (op) {
      op.hide();
    }
    this.confirmationService.confirm({
      message: this.translater.translate('confirmation.deleteSelectedFile'),
      key: 'deleteFileConfirm',
      accept: () => {
        if (
          file.pastellStatus === PastellStatus.AEnvoyer ||
          file.pastellStatus === PastellStatus.EnvoiEnCours ||
          file.pastellStatus === PastellStatus.Envoye
        ) {
          this.toastr.error(this.translater.translate('courrierFiche.errorFileInAPastellStatusNotDeletable') + ' : ' + file.description);
        } else {
          this.filesService.deleteMailFile(this.currentCourrier.id, file.id).subscribe({
            next: () => {
              this.uploadedFiles = this.uploadedFiles.filter((f) => f.id !== file.id);
              this.toastr.success(this.translater.translate('thankYou'), this.translater.translate('courrierFiche.fileDeleted'));
              this.selectedFiles = [];
              this.uploadedFiles.map((_item, index) => {
                this.selected_by_id[index] = false;
              });
              if (this.uploadedFiles.length > 0) {
                this.currentFile.emit(this.uploadedFiles[0]);
                this.currentAmountFile.emit(this.uploadedFiles.length);
              } else {
                this.currentFile.emit(null);
                this.currentAmountFile.emit(this.uploadedFiles.length);
              }
            },
            error: (error) => {
              console.error('Error : ', error);
              this.toastr.error(this.translater.translate('error.errorOccurredWhileDeletingFile'));
            },
          });
        }
      },
    });
  }

  public onOpenFile(file: MailFile, event?): void {
    if (!event || event.target.className !== 'bi bi-chevron-down') {
      if (file) {
        if (this.rightMailInfo?.files?.open) {
          this.filename = file.description ? file.description : file.name;
          this.fileCurrent = file;
          this.currentFile.emit(file); // emit to courrier-fiche-form
          this.currentAmountFile.emit(this.uploadedFiles.length);
        } else {
          this.toastr.error(this.translater.translate('error.authorization.openFile'));
        }
      }
    }
  }

  public setFilename(file: MailFile, op?: OverlayPanel): void {
    if (op) {
      op.hide();
    }
    if (file) {
      this.filename = file.description ? file.description.split('.')[0] : file.name;
      this.fileCurrent = file;
    }
  }

  public download(file: MailFile, op?: OverlayPanel): void {
    if (file) {
      this.iBoxService.downLoadFile(file.mailId, file.id).subscribe({
        next: (res: Blob) => {
          const downloadURL = URL.createObjectURL(res);
          if ((file.description || file.name) && file.extension) {
            saveAs(downloadURL, (file.description ? file.description : file.name) + '.' + file.extension);
          } else {
            this.toastr.error(this.translater.translate('error.errorOccurredWhileSavingFileNoExtensionNorName'));
          }
        },
        error: () => {
          this.toastr.error(this.translater.translate('error.errorOccurredWhileDownloadingFile'));
        },
      });
    } else {
      this.toastr.error(this.translater.translate('error.noFileToDownload'));
    }
    if (op) {
      op.hide();
    }
  }
  public downloadSelectedFiles(): void {
    const files: MailFile[] = [];
    if (this.selectedFiles.length > 0) {
      this.selectedFiles.map((selectedFile) => {
        files.push(this.uploadedFiles[selectedFile]);
      });
      this.downloadAll(files);
    }
  }

  public downloadAll(files: MailFile[]): void {
    if (files.length > 0) {
      async.eachSeries(files, (file: MailFile, next) => {
        if (file.downloadFileRight) {
          this.iBoxService.downLoadFile(file.mailId, file.id).subscribe({
            next: (res: Blob) => {
              const downloadURL = URL.createObjectURL(res);
              saveAs(downloadURL, (file.description ? file.description : file.name) + '.' + file.extension);
              next();
            },
            error: (error) => {
              console.error(error);
              this.toastr.error(this.translater.translate('error.errorOccurredWhileDownloadingFile'));
            },
          });
        } else {
          this.toastr.error("Vous n'avez pas le droit de télécharger ce document : " + file.name);
          next();
        }
      });
    }
  }

  public addNewVersion(file: MailFile, op?: OverlayPanel): void {
    if (op) {
      op.hide();
    }
    const ref = this.dialogService.open(GuardConfirmModalComponent, {
      header: 'Confirmation',
      styleClass: 'super-compos-modal-content ',
      dismissableMask: false,
      width: '30em',
      data: {
        message: this.translater.translate('confirmation.createANewVersion'),
      },
    });
    ref.onClose.subscribe({
      next: (value) => {
        if (value) {
          if (file.editeurSourceType === 'Web') {
            if (value === true) {
              this.router.navigate(['/private/ic/editor/' + this.currentCourrier.id + '/file/' + file.id]);
            }
          } else {
            this.showUploadModalFile = true;
            this.fileCurrent = file;
          }
        }
      },
    });
  }
  public importFromMail(): void {
    this.importModal = true;
    this.launchSearchImport = false;
    setTimeout(() => {
      document.getElementById('autofocus').focus();
    }, 500);
  }

  public searchFilesByCourrierID(courrierID: number): void {
    this.showError = false;
    this.launchSearchImport = true;
    this.filesFromCourriers = [];
    this.filesService.fetchMailFiles(courrierID).subscribe({
      next: (res: MailFileDto[]) => {
        if (res?.length > 0) {
          this.filesFromCourriers = res;
        } else {
          this.filesFromCourriers = [];
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error(this.translater.translate('error.errorOccurredWhileRetrievingMailsFiles'));
        if (error) {
          this.showError = true;
        }
      },
    });
  }
  public validate(): void {
    if (this.selectedTableLines?.length > 0) {
      this.selectedTableLines.map((file) => {
        let fileToDownLoad = null;

        async.waterfall([
          (cb) => {
            if (file) {
              this.iBoxService.downLoadFile(file.mailId, file.id).subscribe({
                next: (res: Blob) => {
                  fileToDownLoad = res;
                  cb(null);
                },
                error: (error) => {
                  console.error(error);
                  this.toastr.error(this.translater.translate('courrierFiche.fileDownloadError'));
                },
              });
            }
          },
          () => {
            this.document = new Document({
              description: file.description ? file.description : file.name,
              version: 1,
            });

            fileToDownLoad.name = file.name;
            this.filesService.addMailFiles(this.currentCourrier.id, this.document, fileToDownLoad, file.extension, file.editeurSourceType).subscribe({
              next: (response) => {
                this.uploadedFiles.push(new MailFile(response));
                this.toastr.success(this.translater.translate('thankYou'), this.translater.translate('courrierFiche.filesAdded'));
              },
              error: (error) => {
                console.error('Error : ', error);
                this.spinner.hide();
                this.isLoading = false;
                this.toastr.error(this.translater.translate('courrierFiche.fileAddError'));
              },
            });
            this.importModal = false;
          },
        ]);
      });
    } else {
      this.toastr.error(this.translater.translate('courrierFiche.pleaseChooseAtLeastOneFile'));
    }
  }

  public updateFile(): void {
    if (this.filename) {
      const data: MailFileParams = {
        description: this.filename,
        editeurSourceType: this.fileCurrent.editeurSourceType,
      };

      this.filesService.patchDescriptionFile(this.currentCourrier.id, this.fileCurrent.id, data).subscribe({
        next: () => {
          this.toastr.success(this.translater.translate('courrierFiche.descriptionModified'));
          this.showDescDialog = false;
          this.getMailsFiles(this.fileCurrent.id);
        },
        error: (error) => {
          console.error(error);
          this.toastr.error(this.translater.translate('error.errorOccurredWhileModifyingDescription'));
        },
      });
    } else {
      this.toastr.error(this.translater.translate('error.errorDescriptionEmpty'));
    }
  }

  public cancel(): void {
    this.importModal = false;
    this.courrierID = null;
    this.filesFromCourriers = [];
  }

  public validationDocument(file: MailFile, validateWithComment: boolean, op?: OverlayPanel): void {
    if (op) {
      op.hide();
    }
    const ref = this.dialogService.open(GuardConfirmModalComponent, {
      header: 'Confirmation',
      styleClass: 'super-compos-modal-content ',
      dismissableMask: false,
      width: '30em',
      data: {
        message: this.translater.translate('confirmation.validateMail'),
      },
    });
    ref.onClose.subscribe({
      next: (value) => {
        if (value) {
          if (value === true) {
            if (validateWithComment === false) {
              const data: MailsFilesAcceptValidationParams = {
                files: [
                  {
                    fileId: file.id,
                    justification: null,
                  },
                ],
              };
              this.spinner.show();
              this.filesService.putAcceptValidation(data, false).subscribe({
                next: () => {
                  this.toastr.success(this.translater.translate('courrierFiche.mailValidated'));
                  this.spinner.hide();
                  this.setMailFilesDatas();
                  this.reloadAfterValidationOrSignatureOfFile.emit({ status: true });
                },
                error: () => {
                  this.spinner.hide();
                  this.toastr.error(this.translater.translate('error.errorOccurredWhileValidatingMail'));
                },
              });
            } else {
              this.showValidateDocument = true;
              this.fileID = file.id;
            }
          }
        }
      },
    });
  }

  public validationComment(): void {
    const data: MailsFilesAcceptValidationParams = {
      files: [
        {
          fileId: this.fileID,
          justification: this.formValidation.value.justification,
        },
      ],
    };
    this.spinner.show();
    this.filesService.putAcceptValidation(data, false).subscribe({
      next: () => {
        this.toastr.success(this.translater.translate('courrierFiche.mailValidated'));
        this.spinner.hide();
        this.showValidateDocument = false;
        this.formValidation.reset();
        this.setMailFilesDatas();
        this.reloadAfterValidationOrSignatureOfFile.emit({ status: true });
      },
      error: () => {
        this.spinner.hide();
        this.toastr.error(this.translater.translate('error.errorOccurredWhileValidatingMail'));
      },
    });
  }

  public refuseSignature(file: MailFile, op?: OverlayPanel): void {
    if (op) {
      op.hide();
    }
    const ref = this.dialogService.open(GuardConfirmModalComponent, {
      header: 'Confirmation',
      styleClass: 'super-compos-modal-content ',
      dismissableMask: false,
      width: '30em',
      data: {
        message: this.translater.translate('confirmation.refuseMailValidation'),
      },
    });
    ref.onClose.subscribe({
      next: (value) => {
        if (value) {
          this.showRefuseSignatureDocument = true;
          this.fileID = file.id;
        }
      },
    });
  }

  public refuseWithComment(): void {
    this.formSignature.value.dateRefus = moment().format('YYYY-MM-DD');
    this.filesService.putRefuseSignature(this.currentCourrier.id, this.fileID, this.formSignature.value).subscribe({
      next: () => {
        this.toastr.success(this.translater.translate('courrierFiche.signatureRejected'));
        this.showRefuseSignatureDocument = false;
        this.setMailFilesDatas();
        this.reloadAfterValidationOrSignatureOfFile.emit({ status: true });
      },
    });
  }

  public refuseValidation(file: MailFile, op?: OverlayPanel): void {
    if (op) {
      op.hide();
    }
    let doesAPreviousStepExists = false; // Autant faire une variable plutôt que faire 3x un find
    this.spinner.show();
    this.columnsRefuse = [
      {
        field: 'ordreDisplayed',
        header: this.translater.translate('docToValidate.colHead.ordre'),
        format: (_value, item) => {
          return item.ordre;
        },
      },
      {
        field: 'defaultRoleName',
        header: this.translater.translate('docToValidate.colHead.defaultRoleName'),
        format: (value) => {
          if (value) {
            return value;
          }
        },
      },
      {
        field: 'serviceLabel',
        header: this.translater.translate('docToValidate.colHead.serviceId'),
        format: (_val, item) => {
          if (item.serviceId) {
            return this.services.find((service) => service.id === item.serviceId)?.description ?? '';
          } else {
            return 'Pas de service';
          }
        },
      },
    ];
    async.waterfall(
      [
        (cb) => {
          /*
          En premier lieu on va récupérer les étapes précédentes
          CAS DE FIGURE 1 
              Si on trouve un id === -1, alors cela veut dire qu'on est à la toute première étape et que le refus va être total pour ce fichier.
              Dans ce cas-ci, le gestionnaire va être obligatoire et sera set de base au créateur du courrier (si celui-ci existe toujours dans les users du service)
              On ne va pas vraiment choisir d'étape. En effet, -1 sera l'id envoyé au back pour signifier qu'on refuse totalement la validation et une action sera créée par le backend.
              Pour l'action, si l'utilisateur est en congé/absent, alors lui ET son remplaçant seront notifiés d'une action.
              Côté utilisateur on garde comme Infodoc et on lui fait choisir celui d'ordre 0
          CAS DE FIGURE 2
              On retrouve au moins une étape. Les étapes vont être renvoyées à l'utilisateur pour qu'il en choisisse une.
              L'étape choisie sera l'étape vers laquelle le fichier va revenir.
              Comme il y a des étapes, l'utilisateur ne devra pas choisir de gestionnaire.
        */

          this.refuseItems = null;
          this.filesService.getPreviousValidation(this.currentCourrier.id, file.id).subscribe({
            next: (res) => {
              file.previousStep = res.sort((a, b) => a.ordre - b.ordre);
              doesAPreviousStepExists = res.some((step) => step.id === -1);
              if (doesAPreviousStepExists) {
                this.formModal.get('contactId').addValidators(Validators.required);
                this.formModal.get('contactId').updateValueAndValidity();
              }
              this.refuseItems = file;
              cb(null);
            },
            error: (error) => {
              console.error(error);
              this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingValidationPrevSteps'));
            },
          });
        },
        (cb) => {
          if (doesAPreviousStepExists) {
            this.servicesService
              .fetchServiceUsersIds(this.currentCourrier.serviceProprietaireId)
              .pipe(
                tap(() => (this.refuseItems['contacts'] = [])),
                switchMap((ids: number[]) => this.usersService.fetchUsersFromiAdmin({ UserIds: `${ids.join(',')}` }))
              )
              .subscribe({
                next: (res: UserDto[]) => {
                  this.refuseItems['contacts'] = res.map((item) => ({
                    label: nameAndSurnameConcatenater(item.contactForUser.prenom, item.contactForUser.nom),
                    value: item.contactForUser.contactId,
                    userId: item.userId,
                  }));
                },
                error: (err: HttpErrorResponse) => {
                  console.error(err);
                  this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingUsers'));
                },
                complete: () => cb(null),
              });
          } else {
            // Si pas de step -1 alors pas besoin de gestionnaire
            cb();
          }
        },
      ],
      () => {
        /*
          Ici on va patcher certaines données.
          Déjà on va patcher le fileId car il ne dépend de rien en condition.
          Ensuite on va voir si on doit patcher le contactId. Le contactId dépend de 2 choses : doesAPreviousStepExists (=> si on doit avoir un gestionnaire) ET si l'utilisateur existe dans la liste
        */
        const creatorOfTheMailIdExistsInList = this.refuseItems['contacts']?.find(
          (contact) => +contact.userId === +this.currentCourrier.createdByUserId
        );
        this.formModal.patchValue({
          fileId: this.refuseItems['id'],
          contactId: doesAPreviousStepExists ? (creatorOfTheMailIdExistsInList?.value ? creatorOfTheMailIdExistsInList.value : null) : null,
        });
        this.refuseModal = true;
        this.spinner.hide();
      }
    );
  }

  public select(item): void {
    this.file = item;
    // On patch le contactId ssi l'id n'est pas -1.
    // Si l'id === -1 ca veut dire qu'on refuse totalement et qu'on permet à l'utilisateur de choisir un gestionnaire => inutile de patcher le gestionnaire vu qu'il est DEJA patché de base
    // Si l'id est !== -1 ca veut dire que le gestionnaire sera la personne ayant accepté la validation
    this.formModal.patchValue({
      previousStepId: item.id,
      previousStepName: item.ordre + ' - ' + item.defaultRoleName + ' - ' + item.serviceLabel,
      contactId: item.id !== -1 ? item.historiqueMostRecent?.fromContactId : this.formModal.value.contactId,
    });
  }

  public submitRefuse(): void {
    this.spinner.show();
    if (this.formModal.valid) {
      async.waterfall([
        (cb) => {
          if (this.formModal.value.contactId) {
            this.contactService.fetchContactsRemplacants(this.formModal.value.contactId).subscribe({
              next: (res) => {
                const hasAbsentPeopleArray = [];

                if (res?.length > 0) {
                  res.map((remplacant) => {
                    if (remplacant.absent === true && this.formModal.value.contactId === remplacant.contactId) {
                      hasAbsentPeopleArray.push(remplacant);
                    }
                  });
                }

                if (hasAbsentPeopleArray.length > 0) {
                  this.confirmationService.confirm({
                    message: this.translater.translate('docToValidate.replaceOnLeave'),
                    key: 'remplacantCourrierCreateAddFiles',
                    accept: () => {
                      this.formModal.patchValue({
                        contactId: hasAbsentPeopleArray[0].remplaceParContactId,
                      });
                      cb(null);
                    },
                    reject: () => {
                      cb(null);
                    },
                  });
                } else {
                  cb(null);
                }
              },
              error: (error) => {
                console.error(error);
                this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingSubstitute'));
              },
            });
          } else {
            cb();
          }
        },
        () => {
          const data: MailsFilesRefuseValidationParams = {
            files: [
              {
                fileId: this.formModal.value.fileId,
                previousStepId: this.formModal.value.previousStepId,
                contactId: this.formModal.value.contactId,
                justification: this.formModal.value.justification,
              },
            ],
          };
          this.filesService.putRefuseValidation(data).subscribe({
            next: () => {
              this.toastr.success(this.translater.translate('courrierFiche.validationRefused'));
              this.spinner.hide();
              this.setMailFilesDatas();
              this.refuseModal = false;
              this.refuseItems = null;
              this.formModal.reset();
              this.reloadAfterValidationOrSignatureOfFile.emit({ status: true });
            },
            error: () => {
              this.spinner.hide();
              this.toastr.error(this.translater.translate('error.errorOccurredWhileRefusingValidation'));
            },
          });
        },
      ]);
    } else {
      this.spinner.hide();
      this.toastr.warning(this.translater.translate('pleaseFulfillRequiredFields'));
    }
  }

  public showHistoriqueValidation(file: MailFile, op?: OverlayPanel): void {
    if (op) {
      op.hide();
    }
    this.spinner.show();
    this.historiqueFile = [];
    this.filesService.getHistoriqueValidationSignature(this.currentCourrier.id, file.id).subscribe({
      next: (res) => {
        if (res?.length > 0) {
          this.historiqueFile = res.map((item) => new HistoryValidationSignature(item));
          this.historiqueFile.map((item) => {
            if (item.fromServiceId) {
              item.fromService = this.services.find((service) => service.id === item.fromServiceId)?.description ?? '';
            }
            if (item.toServiceId) {
              item.toService = this.services.find((service) => service.id === item.toServiceId)?.description ?? '';
            }
            if (item.fromContactId) {
              this.contactService.fetchContact(item.fromContactId, 'iAdmin').subscribe({
                next: (response) => {
                  item.contactName = (response.nom ? response.nom : '') + ' ' + (response.prenom ? response.prenom : '');
                },
              });
            }
          });
          this.showModalHistorique = true;
          this.spinner.hide();
        } else {
          this.spinner.hide();
          this.toastr.warning(this.translater.translate('courrierFiche.noHistory'));
        }
      },
      error: (error) => {
        this.spinner.hide();
        console.error(error);
        this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingHistoric'));
      },
    });
  }
  public showHistoriquePastell(file: MailFile, op?: OverlayPanel): void {
    if (op) {
      op.hide();
    }
    this.historiqueFilePastell = [];
    this.spinner.show();
    this.filesService.getHistoriquePastell(this.currentCourrier.id, file.id).subscribe({
      next: (res) => {
        if (res?.length > 0) {
          this.historiqueFilePastell = res;
          setTimeout(() => {
            this.showModalHistoriquePastell = true;
            this.spinner.hide();
          }, 1000);
        } else {
          this.spinner.hide();
          this.toastr.warning(this.translater.translate('courrierFiche.noPastellHistory'));
        }
      },
      error: (error) => {
        console.error(error);
        this.spinner.hide();
        this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingHistoricPastell'));
      },
    });
  }

  public openPublipostage(file: MailFile, op?: OverlayPanel): void {
    if (op) {
      op.hide();
    }
    this.showPublipostage = true;
    this.fileID = file.id;
    let idsiCourrier: number[] = [];
    let idsiAdmin: number[] = [];
    this.public_contacts = [];
    this.contacts = [];
    this.spinner.show();
    async.waterfall([
      (cb) => {
        this.recipientsService.fetchMailRecipientFullInfos(this.currentCourrier.id).subscribe({
          next: (res) => {
            const listOfRecipientsDestinataire = res.filter((recipient) => recipient.type === 'DESTINATAIRE');
            listOfRecipientsDestinataire.forEach((item) => {
              if (item.contactId) idsiCourrier.push(item.contactId);
              if (item.contactiAdminId) idsiAdmin.push(item.contactiAdminId);
            });
            idsiCourrier = _.uniq(idsiCourrier);
            idsiAdmin = _.uniq(idsiAdmin);
            cb(null);
          },
          error: (error) => {
            console.error(error);
            this.spinner.hide();
            this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingRecipients'));
          },
        });
      },
      (cb) => {
        if (idsiCourrier?.length) {
          this.contactService.fetchSearchContacts({ id: idsiCourrier }, 'iCourrier').subscribe({
            next: (response) => {
              const temp = [];
              if (response.length > 0) {
                response.forEach((contact) => {
                  temp.push({
                    label: contact.name,
                    value: contact.id,
                  });
                });
                this.contacts = temp;
                cb(null);
              }
            },
            error: (error) => {
              console.error('Error : ', error);
              this.spinner.hide();
              this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingContacts'));
            },
          });
        } else {
          this.toastr.info("Aucun destinataire avec un ID de contact provenant de iCourrier n'a été trouvé.");
          cb();
        }
      },
      (cb) => {
        if (idsiAdmin?.length) {
          this.contactService.fetchSearchContacts({ id: idsiAdmin }, 'iAdmin').subscribe({
            next: (response) => {
              const temp = [];
              if (response.length > 0) {
                response.forEach((contact) => {
                  temp.push({
                    label: contact.name,
                    value: contact.id,
                  });
                });
                this.contacts = this.contacts.concat(temp);
                cb(null);
              }
            },
            error: (error) => {
              console.error('Error : ', error);
              this.spinner.hide();
              this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingContacts'));
            },
          });
        } else {
          this.toastr.info("Aucun destinataire avec un ID de contact provenant de IAdmin n'a été trouvé.");
          cb();
        }
      },
      () => {
        this.public_contacts = _.uniq(this.contacts, 'label');
        this.spinner.hide();
      },
    ]);
  }

  public downloadTemplatePublipostage(): void {
    this.filesService.getTemplatePublipostage().subscribe({
      next: (template: Blob) => {
        const blob = new Blob([template], { type: 'application/vnd.ms-excel' });
        const file = new File([blob], 'Modele_pour_publipostage.xlsx', { type: 'application/vnd.ms-excel' });
        saveAs(file);
      },
      error: (error) => {
        console.error(error);
        this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingTemplate'));
      },
    });
  }

  public submitPubli(): void {
    if (this.selectedPublipostageLibre?.length > 0) {
      this.formPubli.value.contactsLibres = this.selectedPublipostageLibre;
    }
    if (this.fileID) {
      this.formPubli.value.fileId = this.fileID;
    }
    this.spinner.show();
    this.filesService.postPublipostage(this.currentCourrier.id, this.formPubli.value.fileId, this.formPubli.value).subscribe({
      next: () => {
        this.toastr.success(this.translater.translate('courrierFiche.mailMergeSuccess'));
        this.showPublipostage = false;
        //! We NEED to send "true" to getMailFiles because like we added files in here, all the files should be sent to setDownloadProperty to set their download property!
        // if we don't do this, file.downloadFileRight will NEVER exist and user won't be able to download any new file
        this.setMailFilesDatas(true);
        this.formPubli.reset();
        this.spinner.hide();
        sessionStorage.removeItem('showModalPublipostageFileID');
      },
      error: () => {
        this.spinner.hide();
        this.toastr.error(this.translater.translate('error.errorOccurredWhileDirectMailing'));
      },
    });
  }

  public annuler(): void {
    this.showPublipostage = false;
    this.formPubli.reset();
    this.spinner.hide();
    sessionStorage.removeItem('showModalPublipostageFileID');
  }

  public onUpload(event): void {
    this.dataExcel = [];
    const target: DataTransfer = <DataTransfer>event;
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e) => {
      /* create workbook */
      const binarystr: string = e.target.result as string;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });
      /* selected the first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      const data = XLSX.utils.sheet_to_json(ws); // to get 2d array pass 2nd parameter as object {header: 1}
      if (data.length > 0) {
        data.map((item, index) => {
          this.dataExcel.push({
            id: index,
            titre: item['PB_TITRE'],
            nom: item['PB_NOM_SEUL'],
            prenom: item['PB_PRENOM_SEUL'],
            adresse: item['PB_ADR'],
            cp: item['PB_CP'],
            loc: item['PB_LOC'],
            mail: item['PB_MAIL'],
            societe: item['PB_SOC'],
            tel: item['PB_TEL'],
            fax: item['PB_FAX'],
          });
        });
      }
    };
  }

  public receive_selected(event: ExcelFilePublipostage[]): void {
    this.selectedPublipostageLibre = event;
  }

  public showPdf(file: MailFile, op?: OverlayPanel): void {
    if (op) {
      op.hide();
    }
    const data = {
      editor: 'devexpress',
      type: '.pdf',
      data: null,
    };
    async.waterfall([
      (cb) => {
        this.spinner.show();
        this.iBoxService.downLoadFile(file['mailId'], file['id']).subscribe({
          next: (response) => {
            const blob = new Blob([response], { type: response.type });
            data.data = blob;
            cb(null);
          },
          error: (error) => {
            console.error('Error : ', error);
            this.toastr.error(this.translater.translate('error.errorOccurredWhileDownloadingFile'));
            this.spinner.hide();
          },
        });
      },
      () => {
        this.documentsService.convertDocument(data).subscribe({
          next: (res: Blob) => {
            this.showPDFModal = true;
            this.spinner.hide();
            setTimeout(() => {
              this.pdfConverted = URL.createObjectURL(res);
            }, 1000);
          },
          error: (error) => {
            console.error(error);
            this.spinner.hide();
            this.toastr.error(this.translater.translate('error.errorOccurredWhileConvertingDocument'));
          },
        });
      },
    ]);
  }

  public changeSourceFile(file: MailFile, op?: OverlayPanel): void {
    if (op) {
      op.hide();
    }
    const ref = this.dialogService.open(ChooseSourceTypeModalComponent, {
      showHeader: false,
      styleClass: 'super-compos-modal-content ',
      dismissableMask: false,
      width: '50em',
    });
    ref.onClose.subscribe({
      next: (value) => {
        if (value) {
          const data: MailFileParams = {
            description: file.description,
            editeurSourceType: value.editeurSourceType,
          };
          this.filesService.patchDescriptionFile(this.currentCourrier.id, file.id, data).subscribe({
            next: () => {
              this.toastr.success(this.translater.translate('courrierFiche.typeModified'));
              file.editeurSourceType = value.editeurSourceType;
            },
            error: (error) => {
              console.error(error);
              this.toastr.error(this.translater.translate('error.errorOccurredWhileModifyingType'));
            },
          });
        }
      },
    });
  }

  public setAsMainDocument(file: MailFile, op?: OverlayPanel): void {
    if (op) {
      op.hide();
    }
    this.filesService.setAsMainDocument(this.currentCourrier.id, file.id).subscribe({
      next: () => {
        this.toastr.success(this.translater.translate('thankYou'), this.translater.translate('courrierFiche.documentSetAsMainDocument'));
        this.getMailsFiles(file.id);
      },
    });
  }

  public addDocument(file: FileSelectEvent, pFileUpload): void {
    let uploaded = null;
    if (file?.files.length > 0) {
      uploaded = _.first(file.files);
    }
    this.spinner.show();
    const docInput: DocumentInput = new DocumentInput({
      pdfFileRequired: true,
      file: new Blob([uploaded], { type: 'application/rtf' }),
      description: this.fileCurrent.name,
      guid: uuidv4(),
      version: this.fileCurrent.version ? this.fileCurrent.version + 1 : 1,
    });
    Object.keys(docInput).forEach((key) => docInput[key] == null && delete docInput[key]);

    this.filesService.addDocumentVersion(this.fileCurrent.mailId, this.fileCurrent.id, docInput, false, false, []).subscribe({
      next: () => {
        this.toastr.success(this.translater.translate('thankYou'), this.translater.translate('courrierFiche.documentCreated'));
        //reload
        this.setMailFilesDatas();
        this.showUploadModalFile = false;
        pFileUpload.clear();
        this.spinner.hide();
      },
      error: (error) => {
        console.error('Error : ', error);
        this.toastr.error(this.translater.translate('error.errorOccurredWhileAddingDocumentVersion'));
        this.spinner.hide();
      },
    });
  }

  public getParagraphes(): void {
    this.spinner.show();
    this.LIST_IDS = [];
    this.documentsService.fetchLibraryParagraphs().subscribe({
      next: (res: LibraryParagraphDto[]) => {
        this.paragraphes = _.groupBy(res, 'bibliothequeName');
        const keys = Object.keys(this.paragraphes);
        keys.forEach((_key, index) => {
          this.LIST_IDS.push('cdk-drop-list-' + index);
        });
        this.spinner.hide();
      },
      error: (error: HttpErrorResponse) => {
        console.error(error);
        this.spinner.hide();
        this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingParagraphs'));
      },
    });
  }

  public copy(text: LibraryParagraphDto): void {
    navigator.clipboard.writeText(text.texteRtf).then(
      function () {
        console.info('Async: Copying to clipboard was successful!');
      },
      function (err) {
        console.error('Async: Could not copy text: ', err);
      }
    );
    this.toastr.success(this.translater.translate('successCopyToClipboard', { value: text.description }));
  }

  public checkboxFiles(event, index: number): void {
    this.selected_by_id[index] = event.target.checked;
    if (event.target.checked) {
      this.selectedFiles.push(index);
      this.selectedFiles = _.uniq(this.selectedFiles);
    } else {
      const indexOf = this.selectedFiles.indexOf(index);
      if (indexOf > -1) {
        this.selectedFiles.splice(indexOf, 1);
      }
    }
  }

  public checkAllFiles(event: { checked: boolean; originalEvent: PointerEvent }): void {
    if (event.checked) {
      this.uploadedFiles.map((_file, index) => {
        this.selectedFiles.push(index);
        this.selected_by_id[index] = true;
      });
      this.selectedFiles = _.uniq(this.selectedFiles);
    } else {
      this.selectedFiles = [];
      this.uploadedFiles.map((_file, index) => {
        this.selected_by_id[index] = false;
      });
    }
  }

  public checkDowloadRight(file: MailFile): boolean {
    const validate1 = this.statusValidation.find((validationStatus) => validationStatus.code === '1');
    const validate2 = this.statusValidation.find((validationStatus) => validationStatus.code === '2');

    const foundTemplate = file.modeleId ? this.modelTemplates.find((template) => template.id === file.modeleId) : null;

    const checkDLValidation = this.checkValidation(file, validate1, validate2, foundTemplate);
    const checkDLSignature = this.checkSignature(file, validate1, validate2, foundTemplate);

    return checkDLSignature && checkDLValidation;
  }

  private checkValidation(
    file: MailFile,
    validate1: {
      label: string;
      value: number;
      code: string;
    },
    validate2: {
      label: string;
      value: number;
      code: string;
    },
    foundTemplate: DocumentTemplateDTO | null | undefined
  ): boolean {
    if (!foundTemplate) {
      //vérifier le statut de validation
      if (!file.procedureValidationValidationId) {
        //si pas de validation alors on permet de DL
        return true;
      } else {
        //si on a une procédure de validation, alors on va vérifier si elle est finie
        if (file.procedureValidationValidationId === validate1.value || file.procedureValidationValidationId === validate2.value) {
          //! ATTENTION ICI J AI MIS 1 ET 2 EN BRUT PARCE QUE LA METHODE api/v2/Global/Documents/ValidationStatutes  GET ne renvoie que des ids, codes et description !!!
          //! Vu avec KHA ce 21/08/2023 : Autant pour la validation que la signature : on se base sur les codes 1 et 2
          return true;
        } else {
          return false;
        }
      }
    } else {
      //si on a un modèleId, on va d'abord vérifier si on peut l'imprimer

      const nePasProposerImprimer = foundTemplate.nePasProposerImprimer;

      if (nePasProposerImprimer === true) {
        // ca veut dire qu'on ne va PAS proposer d'imprimer => on empêche le DL
        return false;
      } else {
        //ne pas proposer d'imprimer est faux => on va proposer d'imprimer => on regarde le statut de validation
        if (!file.procedureValidationValidationId) {
          //si pas de validation alors on permet de DL
          return true;
        } else {
          //si on a une procédure de validation, alors on va vérifier si elle est finie
          if (file.procedureValidationValidationId === validate1.value || file.procedureValidationValidationId === validate2.value) {
            //! ATTENTION ICI J AI MIS 1 ET 2 EN BRUT PARCE QUE LA METHODE api/v2/Global/Documents/ValidationStatutes  GET ne renvoie que des ids, codes et description !!!
            //! Vu avec KHA ce 21/08/2023 : Autant pour la validation que la signature : on se base sur les codes 1 et 2
            return true;
          } else {
            return false;
          }
        }
      }
    }
  }

  private checkSignature(
    file: MailFile,
    validate1: {
      label: string;
      value: number;
      code: string;
    },
    validate2: {
      label: string;
      value: number;
      code: string;
    },
    foundTemplate: DocumentTemplateDTO | null | undefined
  ): boolean {
    if (!foundTemplate) {
      //verifier le statut de la signature
      if (!file.procedureValidationSignatureId) {
        //si pas de validation alors on permet de DL
        return true;
      } else {
        //si on a une procédure de signature, alors on va vérifier si elle est finie
        if (file.procedureValidationSignatureId === validate1.value || file.procedureValidationSignatureId === validate2.value) {
          //! ATTENTION ICI J AI MIS 1 ET 2 EN BRUT PARCE QUE LA METHODE api/v2/Global/Documents/ValidationStatutes  GET ne renvoie que des ids, codes et description !!!
          //! Vu avec KHA ce 21/08/2023 : Autant pour la validation que la signature : on se base sur les codes 1 et 2
          return true;
        } else {
          return false;
        }
      }
    } else {
      //si on a un modèleId, on va d'abord vérifier si on peut l'imprimer
      const nePasProposerImprimer = foundTemplate.nePasProposerImprimer;

      if (nePasProposerImprimer === true) {
        // ca veut dire qu'on ne va PAS proposer d'imprimer => on empêche le DL
        return false;
      } else {
        //ne pas proposer d'imprimer est faux => on va proposer d'imprimer => on regarde le statut de signature
        if (!file.procedureValidationSignatureId) {
          //si pas de signature alors on permet de DL
          return true;
        } else {
          //si on a une procédure de signature, alors on va vérifier si elle est finie
          if (file.procedureValidationSignatureId === validate1.value || file.procedureValidationSignatureId === validate2.value) {
            //! ATTENTION ICI J AI MIS 1 ET 2 EN BRUT PARCE QUE LA METHODE api/v2/Global/Documents/ValidationStatutes  GET ne renvoie que des ids, codes et description !!!
            //! Vu avec KHA ce 21/08/2023 : Autant pour la validation que la signature : on se base sur les codes 1 et 2
            return true;
          } else {
            return false;
          }
        }
      }
    }
  }

  public displayError(error: HttpErrorResponse, messageDisplayed: string): void {
    console.error(error);
    this.loadingDisplay = false;
    this.toastr.error(this.translater.translate(messageDisplayed));
  }
  public openModalAssignCircuitPastell(file: MailFile, op?: OverlayPanel): void {
    if (op) {
      op.hide();
    }
    const ref = this.dialogService.open(ModalAssignPastellCircuitComponent, {
      showHeader: false,
      styleClass: 'super-compos-modal-content ',
      dismissableMask: false,
      width: '70em',
      data: {
        mailId: this.currentCourrier.id,
        file: file,
        listOfFiles: this.uploadedFiles,
      },
    });
    ref.onClose.subscribe({
      next: (value: { reload?: boolean }) => {
        if (value?.reload) {
          this.setMailFilesDatas(false);
        }
      },
    });
  }

  public getSuperButtonAddFilDocumentText(): string {
    if (this.displayFileAddString === 'addFile') {
      return this.translater.translate('courrierFiche.addFile');
    } else return this.translater.translate('courrierFiche.createDocument');
  }

  onRowSelection(event): void {
    this.selectedTableLines = event;
  }
}
